import {Component, Input, HostListener, OnInit, ElementRef} from '@angular/core';
import {TimelineService} from "../../../timeline.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {KenBurnsPresetComponent} from "../../../../ken-burns-preset/ken-burns-preset.component";
import {ImageClip} from "storyboard-renderer";

@Component({
  selector: 'app-clip-menu',
  templateUrl: './clip-menu.component.html',
  styleUrls: ['./clip-menu.component.scss']
})
export class ClipMenuComponent implements OnInit {

  @Input() clipComponent;
  @HostListener('document:click', ['$event.target'])
  outsideClick(target) {
    // Click that opens popover triggers this. Ignore first click.
    if (!this.isActive || this.elementRef.nativeElement.contains(target)) {
      this.isActive = true;
      return;
    } else {
      this.closeMenu();
    }
  }

  isActive = false;
  activeMenu = 'fade';
  opacity = 100;
  fadeIn = 0;
  fadeOut = 0;
  scaleInTime = 0;
  scaleOutTime = 0;
  scaleInFactor = 1;
  scaleOutFactor = 1;
  scaleInOffsetX = 0;
  scaleInOffsetY = 0;
  scaleOutOffsetX = 0;
  scaleOutOffsetY = 0;

  regEx = new RegExp('^-?[0-9]\\d*(\\.\\d+)?$');
  fillColorColorPickerOpen = false;

  constructor(private timelineService: TimelineService, private elementRef: ElementRef, private modalService: NgbModal) { }

  ngOnInit() {

    this.opacity = this.clipComponent.clip.effects.opacity;

    this.fadeIn = this.clipComponent.clip.effects.fadeIn.getUntil().as_milliseconds / 1000;
    this.fadeOut = this.clipComponent.clip.effects.fadeOut.getFrom().as_milliseconds / 1000;

    this.scaleInTime = this.clipComponent.clip.effects.scaleIn.getUntil().as_milliseconds / 1000;
    this.scaleOutTime = this.clipComponent.clip.effects.scaleOut.getFrom().as_milliseconds / 1000;

    this.scaleInFactor = this.clipComponent.clip.effects.scaleIn.getFactor();
    this.scaleOutFactor = this.clipComponent.clip.effects.scaleOut.getFactor();

    this.scaleInOffsetX = this.clipComponent.clip.effects.scaleIn.getOffsetX();
    this.scaleInOffsetY = this.clipComponent.clip.effects.scaleIn.getOffsetY();

    this.scaleOutOffsetX = this.clipComponent.clip.effects.scaleOut.getOffsetX();
    this.scaleOutOffsetY = this.clipComponent.clip.effects.scaleOut.getOffsetY();

    this.timelineService.closeAllClipMenuEvent.next(this.clipComponent.clip);

    console.log(this.clipComponent.clip);
  }

  setActive(item) {
    this.activeMenu = item;
  }

  closeMenu() {
    this.clipComponent.closeClipMenu();
  }

  popoverYes() {
    this.clipComponent.deleteClip(this.clipComponent.clip);
  }

  popoverNo() {
    this.clipComponent.closeClipMenu();
  }

  duplicate() {
    this.clipComponent.duplicateClip(this.clipComponent.clip);
  }

  edit() {
    this.clipComponent.editClip(this.clipComponent.clip);
  }

  fillColorColorPickerOpenChange(open: boolean) {
    this.fillColorColorPickerOpen = open;
  }

  setOpacity(value) {
    this.clipComponent.setOpacity(value.value);
  }

  setFadeOut(value) {

    if (!this.regEx.test(value.toString())) {
      value = this.clipComponent.clip.effects.fadeOut.getFrom().as_milliseconds / 1000;
    }

    if (value >= 5) {
      value = 5;
    }

    this.clipComponent.setFadeOut(value);
  }

  setFadeIn(value) {
    if (!this.regEx.test(value.toString())) {
      value = this.clipComponent.clip.effects.fadeIn.getUntil().as_milliseconds / 1000;
    }

    if (value >= 5) {
      value = 5;
    }

    this.clipComponent.setFadeIn(value);
  }

  setScaleInOffsetX(value) {

    if (!this.regEx.test(value.toString())) {
      value = this.clipComponent.clip.effects.scaleIn.getOffsetX();
    }

    this.clipComponent.setScaleInOffsetX(value);
  }

  setScaleInOffsetY(value) {

    if (!this.regEx.test(value.toString())) {
      value = this.clipComponent.clip.effects.scaleIn.getOffsetY();
    }

    this.clipComponent.setScaleInOffsetY(value);
  }

  setScaleOutOffsetX(value) {

    if (!this.regEx.test(value.toString())) {
      value = this.clipComponent.clip.effects.scaleOut.getOffsetX();
    }

    this.clipComponent.setScaleOutOffsetX(value);
  }

  setScaleOutOffsetY(value) {

    if (!this.regEx.test(value.toString())) {
      value = this.clipComponent.clip.effects.scaleOut.getOffsetY();
    }


    this.clipComponent.setScaleOutOffsetY(value);
  }

  setScaleOutTime(value) {

    if (!this.regEx.test(value.toString())) {
      value = this.clipComponent.clip.effects.scaleOut.getFrom().as_milliseconds / 1000;
    }

    this.clipComponent.setScaleOutTime(value);
  }

  setScaleInTime(value) {
    if (!this.regEx.test(value.toString())) {
      value = this.clipComponent.clip.effects.scaleIn.getUntil().as_milliseconds / 1000;
    }

    this.clipComponent.setScaleInTime(value);
  }

  setScaleOutFactor(value) {

    if (!this.regEx.test(value.toString())) {
      value = this.clipComponent.clip.effects.scaleOut.getFactor();
    }

    if (value >= 5) {
      value = 5;
    }

    this.clipComponent.setScaleOutFactor(value);
  }

  setScaleInFactor(value) {
    if (!this.regEx.test(value.toString())) {
      value = this.clipComponent.clip.effects.scaleIn.getFactor();
    }

    if (value >= 5) {
      value = 5;
    }

    this.clipComponent.setScaleInFactor(value);
  }

  toggleKenBurns($event) {
    this.clipComponent.clip.effects.kenBurnsStatus = $event;
  }

  toggleUnlock($event: any) {
    this.clipComponent.clip.unlocked = $event;
  }

  openKenBurnsPreset() {

    this.closeMenu();

    const kbPresetModal = this.modalService.open(KenBurnsPresetComponent, {windowClass: 'ken-burns-preset-modal', size: 'lg' });

    kbPresetModal.result.then((result) => {
      this.clipComponent.setPreset(result);
    }, (reason) => {});
  }

  fitToScreen() {
    this.clipComponent.fitToScreen();
  }

  scaleToScreen() {
    this.clipComponent.scaleToScreen();
  }

  isImageClip() {
    return this.clipComponent.clip instanceof ImageClip;
  }

  rotate(number: number) {
    this.clipComponent.rotate(number);
  }
}




// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/timeline/video-layer/clip/clip-menu/clip-menu.component.ts